import { Box } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import React from "react";
const noneAnimation = {
    name: "Aucune",
    type: "none",
    wrapper: ({ children }) => {
        return React.createElement(React.Fragment, null, children);
    },
};
const fadeAnimation = {
    name: "Fondu",
    type: "fade",
    wrapper: ({ duration, delay, children, preview = false }) => {
        const fade = keyframes `
      from {opacity: 0;}
      to {opacity: 1;}
    `;
        return (React.createElement(Box, { animation: `${duration}s ${preview ? "infinite" : "1"} ${fade} backwards`, sx: {
                animationDelay: `${delay}s`,
            } }, children));
    },
};
const zoomAnimation = {
    name: "Zoom",
    type: "zoom",
    wrapper: ({ duration, delay, children, preview }) => {
        const zoom = keyframes `
      from {transform: scale(0);}
      to {transform: scale(1);}
    `;
        return (React.createElement(Box, { transformOrigin: "center", animation: `${duration}s ${preview ? "infinite" : "1"} ${zoom} backwards`, sx: {
                animationDelay: `${delay}s`,
            } }, children));
    },
};
export const animations = [
    noneAnimation,
    fadeAnimation,
    zoomAnimation,
];
